export const ru = {
    cancel: 'Отмена',
    'header-hint':
        'Укажите порог отключения, и показы рекламы не остановятся, если на общем счете закончились средства. Для подключения услуги введите сумму в пределах доступной отсрочки платежа. Выберите плательщика и способ оплаты. Если в конце месяца баланс общего счета будет меньше {limit} {currency}, вам будет выставлен счет на сумму задолженности с учётом НДС по указанным данным. Его нужно оплатить в течение 15 дней.',
    'header-hint-no-nds':
        'Укажите порог отключения, и показы рекламы не остановятся, если на общем счете закончились средства. Для подключения услуги введите сумму в пределах доступной отсрочки платежа. Выберите плательщика и способ оплаты. Если в конце месяца баланс общего счета будет меньше {limit} {currency}, вам будет выставлен счет на сумму задолженности без учёта НДС по указанным данным. Его нужно оплатить в течение 15 дней.',
    'header-title': 'Порог отключения',
    'no-payment-methods':
        'Для выбранного плательщика нет доступных способов оплаты, поэтому настроить порог отключения невозможно. Чтобы решить проблему, {writeToUsLink}.',
    payer: 'Плательщик',
    'payment-method': 'Способ оплаты',
    'payment-method-limit': 'до {value} {currency}',
    'switch-off': 'Отключить',
    'switch-off-limit': 'Порог отключения (с НДС), {currency}',
    'switch-off-limit-hint': 'доступный порог –{limit} {currency}',
    'switch-off-limit-no-nds-limit': 'Порог отключения (без НДС), {currency}',
    'switch-on': 'Подключить',
    'write-to-us-link': 'напишите нам'
};
